import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Loader from "../../components/Loader/Loader";
import useApi from "../../hook/useApi";
import { toast } from "react-toastify";
import {
  copyToClipboard,
  formatDateInAMPM,
  trimAddress,
} from "../../utils/helper";
import "react-phone-input-2/lib/style.css";
import { IoCopyOutline } from "react-icons/io5";
import { STANDARD_IMAGE_URL } from "../../utils/constant";
import { Icon } from "@iconify/react/dist/iconify.js";

const NftViewLayer = () => {
  const [loading, setLoading] = useState(false);
  const [nft, setNft] = useState(null);
  const { id } = useParams();
  const { AsyncGetApiCall } = useApi();

  const fetchNft = async () => {
    setLoading(true);
    try {
      const result = await AsyncGetApiCall(`/nft/view-in-admin?id=${id}`);
      console.log("result of fetchNft: ", result);

      if (result.errors) {
        toast.error(result.errors[0]);
      } else if (result.success) {
        setNft(result?.data);
      }
    } catch (error) {
      toast.error("An error occurred while fetching NFT details");
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchNft();
  }, []);

  return (
    <>
      {loading && <Loader />}
      <div className="row gy-4">
        {/* Left Card - NFT Image */}
        <div className="col-lg-4">
          <div className="card position-relative border radius-16 overflow-hidden bg-base">
            <div className="nft-card-overlay">
              <img
                // src={nft?.image ? nft?.image : STANDARD_IMAGE_URL}
                src= {nft?.image}
                alt="NFT"
                className="w-100 object-fit-cover"
                style={{ height: "100%", minHeight: "400px" }}
              />
              <div className="overlay">
                <Icon icon="majesticons:eye-line" className="icon text-2xl" />
              </div>
            </div>
          </div>
        </div>

        {/* Right Column */}
        <div className="col-lg-8">
          {/* Top Right Card - NFT Data */}
          <div className="card mb-10">
            <div className="card-body p-24">
              <h5 className="mb-16">NFT Details</h5>
              <ul>
                <li className="d-flex align-items-center gap-2 mt-4">
                  <span className="w-30 text-md fw-semibold text-primary-light">
                    Id
                  </span>
                  <span>:</span>
                  <span className="w-70 text-secondary-light fw-medium">
                    {trimAddress(nft?._id, 10, 8) || "N/A"}
                    {nft?._id && (
                      <button
                        onClick={() => copyToClipboard(nft?._id)}
                        className="ms-3 p-0 border-0 bg-transparent"
                        style={{ lineHeight: 1 }}
                      >
                        <IoCopyOutline />
                      </button>
                    )}
                  </span>
                </li>
                <li className="d-flex align-items-center gap-2 mt-4">
                  <span className="w-30 text-md fw-semibold text-primary-light">
                    Title
                  </span>
                  <span>:</span>
                  <span className="w-70 text-secondary-light fw-medium">
                    {nft?.title || "N/A"}
                  </span>
                </li>
                <li className="d-flex align-items-center gap-2 mt-4">
                  <span className="w-30 text-md fw-semibold text-primary-light">
                    Description
                  </span>
                  <span>:</span>
                  <span className="w-70 text-secondary-light fw-medium">
                    {nft?.description || "N/A"}
                  </span>
                </li>
                <li className="d-flex align-items-center gap-2 mt-4">
                  <span className="w-30 text-md fw-semibold text-primary-light">
                    Metadata
                  </span>
                  <span>:</span>
                  <span className="w-70 text-secondary-light fw-medium">
                    <a
                      href={nft?.metadata}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {trimAddress(nft?.metadata, 20, 20) || "N/A"}
                    </a>
                    {nft?.metadata && (
                      <button
                        onClick={() => copyToClipboard(nft?.metadata)}
                        className="ms-3 p-0 border-0 bg-transparent"
                        style={{ lineHeight: 1 }}
                      >
                        <IoCopyOutline />
                      </button>
                    )}
                  </span>
                </li>
                <li className="d-flex align-items-center gap-2 mt-4">
                  <span className="w-30 text-md fw-semibold text-primary-light">
                    Royalty
                  </span>
                  <span>:</span>
                  <span className="w-70 text-secondary-light fw-medium">
                    {nft?.royaltyBps ? `${nft.royaltyBps}%` : "N/A"}
                  </span>
                </li>

                <li className="d-flex align-items-center gap-2 mt-4">
                  <span className="w-30 text-md fw-semibold text-primary-light">
                    Royalty Recipient
                  </span>
                  <span>:</span>
                  <span className="w-70 text-secondary-light fw-medium">
                    {trimAddress(nft?.royaltyRecipient, 10, 8) || "N/A"}
                    {nft?.royaltyRecipient && (
                      <button
                        onClick={() => copyToClipboard(nft?.royaltyRecipient)}
                        className="ms-3 p-0 border-0 bg-transparent"
                        style={{ lineHeight: 1 }}
                      >
                        <IoCopyOutline />
                      </button>
                    )}
                  </span>
                </li>

                <li className="d-flex align-items-center gap-2 mt-4">
                  <span className="w-30 text-md fw-semibold text-primary-light">
                    Created By
                  </span>
                  <span>:</span>
                  <span className="w-70 text-secondary-light fw-medium">
                    {nft?.createdBy?.name || "N/A"}{" "}
                    {nft?.createdBy?.userName
                      ? `(@${nft?.createdBy?.userName || "N/A"})`
                      : ""}
                  </span>
                </li>
                <li className="d-flex align-items-center gap-2 mt-4">
                  <span className="w-30 text-md fw-semibold text-primary-light">
                    Created At
                  </span>
                  <span>:</span>
                  <span className="w-70 text-secondary-light fw-medium">
                    {nft?.createdAt ? formatDateInAMPM(nft?.createdAt) : "N/A"}
                  </span>
                </li>
                <li className="d-flex align-items-center gap-2 mt-4">
                  <span className="w-30 text-md fw-semibold text-primary-light">
                    Status
                  </span>
                  <span>:</span>
                  <span className="w-70 text-secondary-light fw-medium">
                    <span
                      className={` badge ${
                        nft?.isApproved
                          ? "bg-success-100 text-success-600"
                          : "bg-danger-100 text-danger-600"
                      } text-sm py-4 px-10 radius-4`}
                    >
                      {nft?.isApproved ? "Active" : "Inactive"}
                    </span>
                  </span>
                </li>
                <li className="d-flex align-items-start gap-2 mt-4">
                  <span className="w-30 text-md fw-semibold text-primary-light">
                    Likes
                  </span>
                  <span>:</span>
                  <div className="w-70 d-flex flex-wrap gap-3 max-h-255 overflow-auto">
                    {nft?.likedBy?.length > 0 ? (
                      nft?.likedBy?.map((like, index) => (
                        <div key={index}>
                          <div className="card p-16 radius-8 border bg-base">
                            <div className="d-flex flex-column align-items-start flex gap-1 flex-wrap">
                              <span className="text-secondary-light fw-medium text-sm">
                                Name: {like?.name || "N/A"}
                              </span>
                              <span className="text-secondary-light fw-medium text-sm">
                                User Name: {like?.userName || "N/A"}
                              </span>
                              <div className="d-flex align-items-center gap-2">
                                <span className="text-secondary-light fw-medium text-sm">
                                  Wallet:{" "}
                                  {like?.walletAddress
                                    ? trimAddress(like?.walletAddress, 4, 4)
                                    : "N/A"}
                                </span>
                                {like?.walletAddress && (
                                  <button
                                    onClick={() =>
                                      copyToClipboard(like.walletAddress)
                                    }
                                    className="p-0 border-0 bg-transparent"
                                    style={{ lineHeight: 1 }}
                                    title="Copy Wallet Address"
                                    aria-label="Copy Wallet Address"
                                  >
                                    <IoCopyOutline className="text-primary-light" />
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <span className="w-70 text-secondary-light fw-medium">
                        N/A
                      </span>
                    )}
                  </div>
                </li>
              </ul>
            </div>
          </div>

          {/* Bottom Right Card - Marketplace Data */}
          <div className="card">
            <div className="card-body p-24">
              <h5 className="mb-16">Marketplace Details</h5>
              <ul>
                <li className="d-flex align-items-center gap-2 mt-4">
                  <span className="w-30 text-md fw-semibold text-primary-light">
                    Id
                  </span>
                  <span>:</span>
                  <span className="w-70 text-secondary-light fw-medium">
                    {trimAddress(nft?.marketPlace?._id, 10, 8) || "N/A"}
                    {nft?.marketPlace?._id && (
                      <button
                        onClick={() => copyToClipboard(nft?.marketPlace?._id)}
                        className="ms-3 p-0 border-0 bg-transparent"
                        style={{ lineHeight: 1 }}
                      >
                        <IoCopyOutline />
                      </button>
                    )}
                  </span>
                </li>
                <li className="d-flex align-items-center gap-2 mt-4">
                  <span className="w-30 text-md fw-semibold text-primary-light">
                    Method
                  </span>
                  <span>:</span>
                  <span className="w-70 text-secondary-light fw-medium">
                    {nft?.marketPlace?.method || "N/A"}
                  </span>
                </li>
                <li className="d-flex align-items-center gap-2 mt-4">
                  <span className="w-30 text-md fw-semibold text-primary-light">
                    Price
                  </span>
                  <span>:</span>
                  {/* <span className="w-70 text-secondary-light fw-medium">
                    {`${nft?.marketPlace?.fixedDetails?.price} ETH` || "N/A"}
                  </span> */}
                  <span className="w-70 text-secondary-light fw-medium">
                    {(() => {
                      const method = nft?.marketPlace?.method;
                      if (method === "FIXED") {
                        return `${
                          nft?.marketPlace?.fixedDetails?.price || 0
                        } ETH`;
                      } else if (method === "AUCTION") {
                        return `${
                          nft?.marketPlace?.auctionDetails?.minBid || 0
                        } ETH - ${
                          nft?.marketPlace?.auctionDetails?.maxBid || 0
                        } ETH`;
                      } else {
                        return "0 ETH";
                      }
                    })()}
                  </span>
                </li>

                <li className="d-flex align-items-center gap-2 mt-4">
                  <span className="w-30 text-md fw-semibold text-primary-light">
                    Expiry
                  </span>
                  <span>:</span>
                  <span className="w-70 text-secondary-light fw-medium">
                    {nft?.marketPlace?.fixedDetails?.expiry
                      ? formatDateInAMPM(nft.marketPlace.fixedDetails.expiry)
                      : "N/A"}
                  </span>
                </li>
                <li className="d-flex align-items-center gap-2 mt-4">
                  <span className="w-30 text-md fw-semibold text-primary-light">
                    Category
                  </span>
                  <span>:</span>
                  <span className="w-70 text-secondary-light fw-medium">
                    {/* {nft?.marketPlace?.category || "N/A"} */}
                    {nft?.category?.name || "N/A"}
                  </span>
                </li>
                <li className="d-flex align-items-center gap-2 mt-4">
                  <span className="w-30 text-md fw-semibold text-primary-light">
                    Collection Address
                  </span>
                  <span>:</span>
                  <div className="d-flex align-items-center w-70 text-secondary-light fw-medium">
                    <span>
                      {nft?.marketPlace?.collectionAddress
                        ? trimAddress(nft.marketPlace.collectionAddress, 10, 8)
                        : "N/A"}
                    </span>
                    {nft?.marketPlace?.collectionAddress && (
                      <button
                        onClick={() =>
                          copyToClipboard(nft.marketPlace.collectionAddress)
                        }
                        className="ms-3 p-0 border-0 bg-transparent"
                        style={{ lineHeight: 1 }}
                      >
                        <IoCopyOutline />
                      </button>
                    )}
                  </div>
                </li>
                <li className="d-flex align-items-center gap-2 mt-4">
                  <span className="w-30 text-md fw-semibold text-primary-light">
                    NFT ID
                  </span>
                  <span>:</span>
                  <div className="d-flex align-items-center w-70 text-secondary-light fw-medium">
                    <span>
                      {nft?.marketPlace?.nftId
                        ? trimAddress(nft.marketPlace.nftId, 10, 8)
                        : "N/A"}
                    </span>
                    {nft?.marketPlace?.nftId && (
                      <button
                        onClick={() => copyToClipboard(nft.marketPlace.nftId)}
                        className="ms-3 p-0 border-0 bg-transparent"
                        style={{ lineHeight: 1 }}
                      >
                        <IoCopyOutline />
                      </button>
                    )}
                  </div>
                </li>

                <li className="d-flex align-items-center gap-2 mt-4">
                  <span className="w-30 text-md fw-semibold text-primary-light">
                    Listing Id
                  </span>
                  <span>:</span>
                  <span className="w-70 text-secondary-light fw-medium">
                    {nft?.marketPlace?.listingId || "N/A"}
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NftViewLayer;
